import Heading from './Heading/Heading';
import Jumbotron from './Jumbotron/Jumbotron';
import FeatureBox from './FeatureBox/FeatureBox';

export default {
  'heading': {
    standard: Heading
  }, 'jumbotron': {
    standard: Jumbotron
  },
  // 'feature-box': {
  //   standard: FeatureBox
  // }
};
